import { tKey } from 'ember-intl';
import { SDLY, SWLY } from 'lumen/utils/reference-period';

export const ASK_ERNEST_PAGES = {
  BOOKINGS: 'bi-bookings',
} as const;

export type AskErnestPage =
  (typeof ASK_ERNEST_PAGES)[keyof typeof ASK_ERNEST_PAGES];

export type AskErnestPromptContext = {
  comparison: string;
  endDate: string;
  property: string;
  startDate: string;
};

// The page's comparison selector also carries values Ernest cannot read, such as
// a custom period, so anything else falls back to SWLY, the page default.
export const ASK_ERNEST_COMPARISONS = [SDLY, SWLY];
export const DEFAULT_ASK_ERNEST_COMPARISON = SWLY;

export type AskErnestPrompt = {
  buildMessage: (context: AskErnestPromptContext) => string;
  id: string;
  label: string;
};

export const BOOKINGS_PROMPTS: AskErnestPrompt[] = [
  {
    id: 'needs-attention',
    label: tKey('general.ask_ernest.prompts.needs_attention'),
    buildMessage: ({ endDate, property, startDate }) =>
      `Review the anomalies for ${property} for stay dates ${startDate} to ${endDate} and suggest a strategy change for each.`,
  },
  {
    id: 'one-day-pickup',
    label: tKey('general.ask_ernest.prompts.one_day_pickup'),
    buildMessage: ({ endDate, property, startDate }) =>
      `For ${property} during the period of ${startDate} and ${endDate}. Give me an overview of what has been picked up yesterday by stay date and by market segment.`,
  },
  {
    id: 'segment-drilldown',
    label: tKey('general.ask_ernest.prompts.segment_drilldown'),
    buildMessage: ({ comparison, endDate, property, startDate }) =>
      `For ${property} during the period of ${startDate} and ${endDate}. Provide the segment drill down and compare vs ${comparison}.`,
  },
];
